import { alpha, Button } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/system';
import { getGlassCtaButtonSx } from '../common/GlassCtaButton';

/** Glass CTA look from getGlassCtaButtonSx + swipe shimmer + .motor-icon ride (not the GlassCtaButton wrapper). */
const GlassSwipeButton = styled(Button)(({ theme }) => {
    const t = theme as Theme;
    const glass = getGlassCtaButtonSx(t);
    const glassHover = glass['&:hover'] as Record<string, unknown> | undefined;
    const isDark = t.palette.mode === 'dark';
    const pm = t.palette.primary.main;

    return {
        '@keyframes glassSwipe': {
            '0%': { left: '-75%' },
            '50%': { left: '125%' },
            '100%': { left: '125%' },
        },
        '@keyframes rideAcross': {
            '0%': { left: '0%' },
            '100%': { left: '100%' },
        },
        '&&': {
            ...glass,
            position: 'relative',
            overflow: 'hidden',
            zIndex: 0,
            minHeight: 62,
            justifyContent: 'center',
            fontSize: "18px",
            pr: { xs: 5.5, sm: 6.5 },
            /* Jači brand na landing pozadini (ostali Glass CTA ostaju kao u getGlassCtaButtonSx). */
            border: `2px solid ${alpha(pm, isDark ? 0.72 : 0.5)}`,
            background: `linear-gradient(135deg, ${alpha(pm, isDark ? 0.42 : 0.26)} 0%, ${alpha(pm, isDark ? 0.16 : 0.1)} 100%)`,
            boxShadow: `0 8px 32px ${alpha(t.palette.common.black, isDark ? 0.35 : 0.08)}, 0 0 28px ${alpha(pm, 0.22)}`,
            '& .MuiButton-endIcon': {
                position: 'absolute',
                right: t.spacing(2),
                top: '50%',
                transform: 'translateY(-50%)',
                marginLeft: 0,
                marginRight: 0,
                transition: 'transform 0.2s ease, color 0.2s ease',
                color: t.palette.primary.light,
            },
            '& .MuiButton-label': {
                position: 'relative',
                zIndex: 2,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
            },
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: '-75%',
                width: '50%',
                height: '100%',
                background:
                    'linear-gradient(120deg, rgba(255,255,255,0.12), rgba(255,255,255,0.38), rgba(255,255,255,0.12))',
                transform: 'skewX(-20deg)',
                animation: 'glassSwipe 2.3s infinite',
                zIndex: 1,
                pointerEvents: 'none',
            },
            '& .motor-icon': {
                position: 'absolute',
                top: '20px',
                left: 0,
                zIndex: 3,
                fontSize: '24px',
                animation: 'rideAcross 2s linear infinite',
            },
            '&:hover': {
                ...(glassHover ?? {}),
                borderColor: pm,
                background: `linear-gradient(135deg, ${alpha(pm, isDark ? 0.52 : 0.34)} 0%, ${alpha(pm, isDark ? 0.22 : 0.14)} 100%)`,
                boxShadow: `0 10px 28px ${alpha(t.palette.common.black, isDark ? 0.35 : 0.12)}, 0 4px 20px ${alpha(pm, 0.14)}, 0 0 36px ${alpha(pm, 0.28)}`,
                '& .MuiButton-endIcon': {
                    transform: 'translateY(-50%) translateX(5px)',
                    color: t.palette.primary.light,
                },
            },
        },
    };
});

export default GlassSwipeButton;
